import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/tags")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/knowledges/tags", search: location.search, replace: true });
  },
  component: () => null,
});
